import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Användare", -1)
const _hoisted_2 = { class: "row mt-3 mb-3" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "table table-sm table-striped table-bordered" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Användarnamn"),
    /*#__PURE__*/_createElementVNode("th", null, "Epost"),
    /*#__PURE__*/_createElementVNode("th", null, "Roller"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_6 = { class: "badge bg-secondary me-1" }
const _hoisted_7 = { class: "btn-group" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_change_password_button = _resolveComponent("change-password-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary btn-sm",
          to: "/admin/users/createaccount"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Skapa ny användare")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.accounts, (account) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: account.userId
          }, [
            _createElementVNode("td", null, _toDisplayString(account.userName), 1),
            _createElementVNode("td", null, _toDisplayString(account.email), 1),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(account.roles, (role, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(role), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_change_password_button, { userAccount: account }, null, 8, ["userAccount"]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editAccount(account.userId)),
                  class: "btn btn-sm btn-primary",
                  title: "Ändra användare"
                }, _hoisted_10, 8, _hoisted_8)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}